import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCfdiConfiguracion', {
    template: template,
    controller: NominasNominaDocumentosCfdiConfiguracionComponent,
    bindings: {
      data: '<',
      onChange: '&',
      onClose: '&',
    },
  })

function NominasNominaDocumentosCfdiConfiguracionComponent() {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.cancelar = cancelar
  $ctrl.omitirEnviados = omitirEnviados

  $ctrl.generar = generar
  $ctrl.validar = validar

  $ctrl.email_omitir_enviados = true
  $ctrl.pdf_dual = true
  $ctrl.agrupar_area = false
  $ctrl.agrupar_departamento = false

  function $onInit() {
    $ctrl.data.forEach(function (item) {
      item.generar_pdf = true
      item.generar_xml = item.status_timbrado ? true : null
      item.enviar_email = emailEnviable(item) ? null : false
    })

    omitirEnviados()
  }

  function cancelar() {
    $ctrl.onClose()
  }

  function emailEnviable(item) {
    return !item.status_timbrado || item.email === null
  }

  function generar() {
    let data = $ctrl.seleccionados.map(function (item) {
      return {
        id_proyecto: item.id_proyecto,
        id_nomina: item.id_nomina,
        id_colaborador: item.id_colaborador,
        colaborador: item.colaborador,
        area: item.area,
        departamento: item.departamento,
        documentos: null,
        email: item.email,
        email_enviado: false,
        opciones: {
          enviar_email: item.enviar_email === true,
          generar_xml: item.generar_xml === true,
          generar_pdf: item.generar_pdf === true,
          pdf_dual: $ctrl.pdf_dual === true,
          agrupar_area: $ctrl.agrupar_area === true,
          agrupar_departamento: $ctrl.agrupar_departamento === true,
        },
      }
    })

    $ctrl.onChange({$event: {data: data}})
  }

  function omitirEnviados() {
    $ctrl.data = $ctrl.data.map(function (item) {
      item.enviar_email = emailEnviable(item)
        ? null
        : (($ctrl.email_omitir_enviados && item.email_enviado) ? null : item.enviar_email === true)

      return item
    })
  }

  function validar() {
    $ctrl.seleccionados = $ctrl.data.filter(function (item) {
      return item.enviar_email || item.generar_pdf || item.generar_xml
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cfdi/configuracion/component.js